import { PWA_AUTO_LOCATION_KEY, SHARE_UUID_KEY, UTM_ACT_KEY } from "@/const/storage-key";
import { atomWithStorage } from "jotai/utils";

// 归因uuid
export const attributeUUIDAtom = atomWithStorage<string>(SHARE_UUID_KEY, '');

// utm_act
export const utmActAtom = atomWithStorage<string>(UTM_ACT_KEY, '');

// pwa 记录是否首次自动定位
export const pwaAutoLocationAtom = atomWithStorage<string>(PWA_AUTO_LOCATION_KEY, '');